<template>
    <div class="footer" >
        <el-row class="foot">
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content bg-purple">&nbsp;</div></el-col>
            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                <div class="grid-content bg-purple-light right" >
                    <span class="back" @click="backTop"> top</span>
                    <!-- <div v-for="(item,k) in footerImg" :key="k">
                        <a :href="item.linkurl" target="_blank"><img :src="item.pictureurl"></a>
                    </div> -->
                    <ul>
                        <li>中文域名：<span>中俄在线投资实业联合会</span> </li>
                        <!-- <li>主办单位：<span>中俄在线投资实业联合会</span></li> -->
                        <li>备案序号：<img src="../assets/icon.png" alt=""> <span><a href="https://beian.miit.gov.cn" style="color:#fff;text-decoration:none">津公网安备 12011602001163号</a> </span> </li>
                        
                        <li>俄文域名：<span>китайско - российский союз предприятий</span> </li>
                        
                    </ul>
                    <ul class="adress">
                        <li>Copyright @ www.1231.com , All Rights asdasdsa</li>
                        <li>地址: <span>北京市朝阳区</span> </li>
                        <li>语言类别: <span>中文服务</span> </li>
                    </ul>
                    

                </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content bg-purple">&nbsp;</div></el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name:"footer",
    data () {
        return {
            minHeight:0,
            
        }
    },
    mounted() {
        
        window.addEventListener('scroll', this.scrollToTop)
    },
    
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods:{
        backTop(){
            //点击返回顶部，
            const that = this;
            let ispeed = Math.floor(-that.scrollTop / 5)
            document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        },
        
    }
}
</script>
<style scoped >
    .footer{
        /* position: relative;
        left:0;
        bottom:0; */
        width:100%;
        /* height:120px; */
        box-sizing: border-box;
        padding:10px 0;
        color:#fff;
        margin-top:40px;
        background-color: #000;
    }
    .foot{
        text-align: center;
    }
    .foot div .back{
        
        display:block;
        width:100px;
        height:60px;
        text-align: center;
        line-height:40px;
        border-radius: 30px;
        color:#fff;
        margin:-30px auto 0;
        background-color: #000;
    }
     .foot ul  {
        float: left;
        font-size:12px;
    }
    .foot ul  li{
        float:left;
        list-style:none;
        text-align: center;
        box-sizing: border-box;
        padding:20px 10px;
        
    }
    img{
        height:20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/footerPage.vue